import React, { useState } from "react";
import { AiFillCaretDown, AiFillCaretRight } from "react-icons/ai";

const LEVEL_COLORS = [
  "#f8f9fa", // Level 0
  "#e9ecef", // Level 1
  "#dee2e6", // Level 2
  "#ced4da", // Level 3
  "#adb5bd", // Level 4
  "#6c757d", // Level 5+
];

const SubTreeItem = ({ item, translate, level = 0, parentId }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const maxLevel = LEVEL_COLORS.length - 1;
  const currentLevel = Math.min(level, maxLevel);

  const paddingLeft = level * 12 + 8;

  const hasChildren = item.subTree && item.subTree.length > 0;

  const toggleExpand = () => {
    if (hasChildren) {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <div className="SubTreeItem" data-level={level}>
      <div
        className={`SubTreeItemHeader d-flex align-items-center ${hasChildren ? "clickable" : ""}`}
        style={{
          backgroundColor: LEVEL_COLORS[currentLevel],
          paddingLeft: `${paddingLeft}px`,
          cursor: hasChildren ? "pointer" : "default",
          fontSize: level === 0 ? "16px" : "14px",
          fontWeight: level === 0 ? "600" : level === 1 ? "500" : "normal",
        }}
        onClick={toggleExpand}
      >
        <div className="SubTreeItemIndicator">
          {hasChildren && (
            isExpanded ? (
              <AiFillCaretDown/>
            ) : (
              <AiFillCaretRight/>
            )
          )}
        </div>

        <span className="SubTreeItemName">
          {item.name}
        </span>
      </div>

      {hasChildren && isExpanded && (
        <div className="SubTreeChildren">
          {item.subTree.map((childItem) => (
            <SubTreeItem
              key={childItem.id}
              item={childItem}
              translate={translate}
              level={level + 1}
              parentId={item.id}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SubTreeItem;